const GlobalEventListeners = {
  resizeOnLoad: `
    if (window.ee) {
      window.ee.on("resize-onload", () => {
        if (typeof window['chart_' + globalEventDOMId] !== "undefined") {
          window['chart_' + globalEventDOMId].resize();
        }
      })
    }
  `,

  dashboardComponentLoad: `
    if (window.spSocket) {
      window.spSocket.send({
        eventName: "system",
        data: {
          component: eventId,
          type: "dashboardComponentLoad"
        }
      });
    }
  `
}

export default GlobalEventListeners;
